import { render, staticRenderFns } from "./ArticleNoNav.vue?vue&type=template&id=5144dcd4&scoped=true&"
import script from "./ArticleNoNav.vue?vue&type=script&lang=js&"
export * from "./ArticleNoNav.vue?vue&type=script&lang=js&"
import style0 from "./ArticleNoNav.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ArticleNoNav.vue?vue&type=style&index=1&id=5144dcd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5144dcd4",
  null
  
)

export default component.exports